import React, { Component } from 'react'
import FallbackDashboardComponent from './FallbackDashboardComponent'

export default class FallbackDashboard extends Component {
    render() {
        return (
            <FallbackDashboardComponent />
        )
    }
}
